export default __webpack_public_path__ + "static/media/info-2.1695995f.svg";